var React = require('react');

function Heart2Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.47 9.817a9.625 9.625 0 00-13.614 0L21 11.672l-1.855-1.855A9.627 9.627 0 005.53 23.432l1.855 1.855L21 38.902l13.615-13.615 1.855-1.855a9.625 9.625 0 000-13.615z","fill":"currentColor","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Heart2Icon.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Heart2Icon;

Heart2Icon.default = Heart2Icon;
